<template>
  <article
    v-if="currentPage && currentPage.protection.locked === false"
    class="margin_large_bottom single-help single-inspiration"
    id="htlp-page"
  >
    <PageHeader />
    <ModuleBuilder
      v-if="currentPage.acf && currentPage.acf.modules"
      class="modules"
      :modules="currentPage.acf.modules"
    />
    <RelatedInspirations
      v-if="currentPage && currentPage.acf"
      title="Kanskje du er interessert i dette også?"
      :categories="currentPage.acf._categories"
    />
  </article>
  <PassProtected
    v-else-if="currentPage && currentPage.protection.locked === true"
  >
  </PassProtected>
</template>

<script>
import RelatedInspirations from "@/components/modules/RelatedInspirations";

export default {
  name: "single-inspiration",
  components: {
    RelatedInspirations
  },
  data() {
    return {};
  },
  computed: {}
};
</script>

<style lang="scss">
@import "./../assets/scss/mixins.scss";
@import "./../assets/scss/vars.scss";
.single-help {
}
</style>
